import { assign, createMachine } from 'xstate';
import { Context, Events } from './types';

const initialContext = {
  automaticallyResumeAt: null,
  error: null,
  resumptionCharge: null,
} as Context;

export const resumeSubscription = createMachine<Context, Events>({
  id: 'resumeSubscription',
  predictableActionArguments: true,
  initial: 'idle',
  context: initialContext,
  states: {
    idle: {
      on: {
        GET_RESUMPTION_CONFIG: 'loading',
        RESUME_SUBSCRIPTION: 'resumeSubscription',
        RESUME_SUBSCRIPTION_AT: 'resumeSubscriptionAt',
      },
    },
    loading: {
      invoke: {
        src: 'getSubscriptionResumptionConfig',
        onDone: {
          target: 'idle',
          actions: assign({
            resumptionCharge: (_ctx, event) => event.data.resumptionCharge,
          }),
        },
      },
    },
    resumeSubscription: {
      invoke: {
        src: 'resumeSubscription',
        onDone: {
          actions: 'setSubscriptionActive',
          target: 'success',
        },
        onError: {
          target: 'error',
          actions: 'setError',
        },
      },
    },
    resumeSubscriptionAt: {
      invoke: {
        src: 'updateSubscriptionAutoResumption',
        onDone: {
          actions: 'updateSubscription',
          target: 'success',
        },
        onError: {
          target: 'error',
          actions: 'setError',
        },
      },
    },
    success: {
      type: 'final',
    },
    error: {
      type: 'final',
    },
  },
});
